<template>
  <!-- Kontener główny widoku z dwoma sekcjami: filtrami i główną treścią -->
  <div class="content-container">
    <!-- Komponent filtrów do wyszukiwania archiwalnych pomiarów (np. wybór dat, lokalizacji) -->
    <filters-archival-measurements />
    <div class="content-wrap">
      <!-- Pasek menu u góry strony -->
      <TopMenu />
      <!-- Główna zawartość – komponent z listą tablic czarnych (BlackList) -->
      <BlackList />
    </div>
  </div>
</template>

<script>
// Import komponentów używanych w tym widoku
import TopMenu from "../components/TopMenu.vue";
import FiltersArchivalMeasurements from "../components/FiltersArchivalMeasurements.vue";
import BlackList from "../components/BlackList.vue";

export default {
  name: "BlackListView", // Nazwa widoku (przydatna np. przy debugowaniu)
  components: {
    TopMenu,
    BlackList,
    FiltersArchivalMeasurements,
  },
  methods: {
    // Metoda pomocnicza do czyszczenia stanu filtrów/widoku – nieużywana bezpośrednio tutaj, ale gotowa na przyszłość
    clear() {
      this.archival.clear();
      this.step = this.archival.step;
      this.isResult = this.archival.isResult;
    },
  },
};
</script>

<style scoped>
/* Tło widoku — neutralne, spokojniejsze niż wcześniejszy „kremowy" odcień. */
.content-container {
  background-color: #eef0ec;
}
</style>
